<template>
  <div :style="styles">
    <div id="top-ad" class="advertising" v-if="ad.top.height !== '0px'">
      <iframe :src="ad.top.url"></iframe>
    </div>
    <v-main class="main-base">
      <v-container class="main-container" fluid>
        <v-row justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-img
              src="../assets/iBowKINTAI-Horizontal-green.svg"
              max-width="100%"
              :height="logoHeight"
            />
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-10 font-weight-bold">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title
                  >iBowKINTAIログインパスワードを忘れた方</v-toolbar-title
                >
              </v-toolbar>
              <v-form
                v-on:submit.prevent="adminPasswordRemind"
                ref="adminPasswordForm"
              >
                <v-card-text>
                  <v-text-field
                    :autofocus="!ckdata"
                    label="事業所コード"
                    name="office_code"
                    prepend-icon="mdi-office-building"
                    type="text"
                    v-model="office_code"
                    :rules="[
                      () => !!office_code || '事業所コードは必須入力です。',
                    ]"
                  />

                  <v-text-field
                    label="職員ID"
                    name="login"
                    prepend-icon="mdi-account"
                    autocomplete="username"
                    type="text"
                    v-model="userid"
                    :rules="[() => !!userid || '職員IDは必須入力です。']"
                    :error-messages="errorMessages"
                  />
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    class="font-weight-bold"
                    color="cancel"
                    dark
                    :disabled="loading"
                    :loading="loading"
                    @click="$emit('endAdminPassword')"
                    >戻る</v-btn
                  >
                  <v-btn
                    class="font-weight-bold"
                    color="primary"
                    type="submit"
                    :disabled="loading"
                    :loading="loading"
                    >本人確認メール送信する</v-btn
                  >
                </v-card-actions>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="mt-3 mx-1 text-caption" justify="center">
          <span
            >ご本人様を確認させていただくURLをお送りいたしますので、メールをご確認の上お手続きください。</span
          >
        </v-row>
        <v-dialog v-model="loading" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              Loading...
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
      <div id="bottom-ad" class="advertising" v-if="ad.bottom.height !== '0px'">
        <iframe :src="ad.bottom.url"></iframe>
      </div>
    </v-main>
  </div>
</template>

<script>
import cookieMixin from "../mixins/cookieMixin.js";
import jwtMixin from "../mixins/jwtMixin.js";

export default {
  mixins: [cookieMixin, jwtMixin],
  data: () => ({
    ckdata: false,
    office_code: "",
    userid: "",
    loading: false,
    errorMessages: "",
    ad: { top: { url: "", height: "0px" }, bottom: { url: "", height: "0px" } },
  }),
  created: function () {
    const office_code = this.getCookie("office_code");
    const userid = this.getCookie("userid");
    if (office_code) {
      this.office_code = office_code;
    }
    if (userid) {
      this.userid = userid;
      this.ckdata = true;
    }
    this.fetchAd();
  },
  computed: {
    styles() {
      return {
        "--top-ad-height": this.ad.top.height,
        "--bottom-ad-height": this.ad.bottom.height,
      };
    },
    logoHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 203;
        case "sm":
          return 137;
        case "md":
          return 99;
        case "lg":
          return 147;
        default:
          return 203;
      }
    },
  },
  methods: {
    adminPasswordRemind() {
      if (!this.$refs.adminPasswordForm.validate()) return;
      this.errorMessages = "";
      window.axios
        .post(window.base_url + "/remind/auth", {
          officecd: Number(this.office_code),
          s_id: this.userid,
        })
        .then(
          function () {
            // cookei保存
            this.setCookie("office_code", this.office_code, {
              "max-age": 864000,
              samesite: "strict",
            });
            this.setCookie("userid", this.userid, {
              "max-age": 864000,
              samesite: "strict",
            });
            this.loading = false;
            this.$emit("displaySnackbar", "メールを送信しました。");
            this.$emit("endAdminPassword");
          }.bind(this)
        )
        .catch(
          function (error) {
            this.loading = false;
            if (error.response && error.response.status == 401) {
              this.errorMessages = error.response.data.message;
            } else {
              alert("サーバでエラーが発生しました。\n(" + error + ")");
              console.log(error);
              console.log(error.response);
            }
          }.bind(this)
        );
    },
    fetchAd() {
      window.axios
        .get(window.base_url + "/system/config/advertising")
        .then(
          function (response) {
            // 情報セット
            console.log(response);
            // this.ad.top = {url: "/advertising/ad1.html", height: "100px"}
            // this.ad.bottom = {url: "/advertising/ad2.html", height: "250px"}
            if (response.data.code === 0) {
              const ad = response.data.advertising;
              if (ad.top_url !== "" && ad.top_height !== 0) {
                this.ad.top = { url: ad.top_url, height: `${ad.top_height}px` };
              }
              if (ad.bottom_url !== "" && ad.bottom_height !== 0) {
                this.ad.bottom = {
                  url: ad.bottom_url,
                  height: `${ad.bottom_height}px`,
                };
              }
            }
          }.bind(this)
        )
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },
  },
};
</script>

<style lang="scss" scoped>
.main-base {
  padding-top: calc(var(--top-ad-height)) !important;
  padding-bottom: 0px !important;
  .main-container {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}

.advertising {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  background: #ffffff77;
  iframe {
    height: 100%;
    width: 100%;
    border: none;
    vertical-align: bottom;
  }
}

#top-ad {
  position: fixed;
  z-index: 3;
  height: calc(var(--top-ad-height));
  width: 100%;
}

#bottom-ad {
  height: calc(var(--bottom-ad-height));
  width: 100%;
}
</style>